import { render, staticRenderFns } from "./Positive.vue?vue&type=template&id=1db3e99b"
import script from "./Positive.vue?vue&type=script&lang=js"
export * from "./Positive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports